import FontScaleToolbar, { readFontScale } from './FontScaleToolbar';
import { ClinicalFontScaleProvider } from './ClinicalFontScaleContext';
import { Progress } from '../ui/progress';
import { useEffect, useState } from 'react';
import './clinicalFormScale.css';

export default function ClinicalFormShell({
  title,
  subtitle,
  stepIndex,
  stepCount,
  stepTitle,
  children,
  footer,
  fontScale: controlledScale,
  onFontScaleChange,
}) {
  const [scale, setScale] = useState(controlledScale || readFontScale());

  useEffect(() => {
    if (controlledScale) setScale(controlledScale);
  }, [controlledScale]);

  const setAndPersist = (v) => {
    setScale(v);
    try {
      localStorage.setItem('hcFontScale', v);
    } catch {
      /* ignore */
    }
    onFontScaleChange?.(v);
  };

  const progress = stepCount > 0 ? ((stepIndex + 1) / stepCount) * 100 : 0;

  return (
    <ClinicalFontScaleProvider scale={scale}>
      <div
        className="clinical-form-root space-y-4"
        style={{ '--hc-font-scale': scale }}
      >
        <div className="flex flex-wrap items-start justify-between gap-3">
          <div>
            {title ? <h2 className="font-heading text-2xl font-bold">{title}</h2> : null}
            {subtitle ? <p className="text-muted-foreground text-sm mt-1">{subtitle}</p> : null}
          </div>
          <FontScaleToolbar scale={scale} onChange={setAndPersist} />
        </div>
        {stepCount > 1 ? (
          <div className="space-y-2">
            <div className="flex justify-between text-sm text-muted-foreground">
              <span>
                Paso {stepIndex + 1} de {stepCount}: {stepTitle}
              </span>
              <span>{Math.round(progress)}%</span>
            </div>
            <Progress value={progress} className="h-2" />
          </div>
        ) : null}
        <div className="rounded-xl border border-border bg-card p-4 md:p-6">{children}</div>
        {footer ? <div className="flex flex-wrap gap-2 justify-end">{footer}</div> : null}
      </div>
    </ClinicalFontScaleProvider>
  );
}
